import { EmojiReactionType } from "modules/emoji/Reactions/types";
import { ANIMATION_DURATION } from "modules/broadcast/AudienceView/constants";
import { traverseSlots } from "./traverseSlots";

export function createSlotsWithReactedUser(
  slots: (string | null)[],
  lastReactionTimeByUserId: {
    [userId: string]: { reactionType: EmojiReactionType; time: number };
  },
  reactedUserId: string,
): (string | null)[] {
  if (slots.includes(reactedUserId)) return slots;

  const isEmptySlotExists = slots.includes(null);
  let hasInsertedReactedUser = false;

  return traverseSlots(slots, (slotValue) => {
    if (hasInsertedReactedUser) return slotValue;

    if (slotValue === null) {
      hasInsertedReactedUser = true;

      return reactedUserId;
    }

    const shouldReplaceCurrentUser =
      !isEmptySlotExists &&
      ((slotValue in lastReactionTimeByUserId &&
        Date.now() - lastReactionTimeByUserId[slotValue].time >
          ANIMATION_DURATION) ||
        !(slotValue in lastReactionTimeByUserId));

    if (shouldReplaceCurrentUser) {
      hasInsertedReactedUser = true;

      return reactedUserId;
    }

    return slotValue;
  });
}
